import { render, staticRenderFns } from "./ReceptionCertificateSignature.vue?vue&type=template&id=f5047f8c&scoped=true&"
import script from "./ReceptionCertificateSignature.vue?vue&type=script&lang=js&"
export * from "./ReceptionCertificateSignature.vue?vue&type=script&lang=js&"
import style0 from "./ReceptionCertificateSignature.vue?vue&type=style&index=0&id=f5047f8c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5047f8c",
  null
  
)

export default component.exports